import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Checkbox, Form, FormItem, Text } from 'common-components';
import { FiltersDrawer, FiltersDrawerFooter } from '@components/display';
import { css } from '@emotion/react';
import { useAppTranslation } from '@hooks';
import { QuestionState } from '@definitions';
import { CommonFilters, StateCheckbox } from '@components/inputs';
import { GetCertificationQuestionsPayloadType } from '@api';

type FiltersQuestionsCertificationPropsType = {
  visible: boolean
  idCertification: string
  onFiltersChange: (filters: GetCertificationQuestionsPayloadType) => void
  onClose?: () => void
};

const FiltersQuestionsCertification = ({
  visible,
  onClose,
  onFiltersChange,
  idCertification,
}: FiltersQuestionsCertificationPropsType) => {
  const { translate } = useAppTranslation();
  const { control, handleSubmit, reset } = useForm<GetCertificationQuestionsPayloadType>({
    defaultValues: {
      model: {
        idCertification,
      },
    },
  });

  const onSubmit = (data: GetCertificationQuestionsPayloadType) => {
    onFiltersChange(data);
    onClose && onClose();
  };

  return (
    <FiltersDrawer open={visible} onClose={onClose}>
      <Form onFinish={handleSubmit(onSubmit)} css={$form}>
        <CommonFilters control={control} />

        <Controller
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.state')}>
              <StateCheckbox
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
                values={QuestionState}
                labelTxKey={'questionState'}
                preset={'question-state'}
              />
            </FormItem>
          )}
          name={'model.state'}
        />

        <Controller
          name={'model.training'}
          control={control}
          render={({ field }) => (
            <FormItem>
              <Checkbox
                onChange={(ev) =>
                  field.onChange({
                    ...ev,
                    target: { ...ev.target, value: ev.target.checked },
                  })
                }
                checked={field.value}
              >
                <Text>{translate('certificationPage.questionsTable.training')}</Text>
              </Checkbox>
            </FormItem>
          )}
        />

        <FiltersDrawerFooter>
          <Button onClick={() => reset()}>{translate('common.buttons.cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {translate('common.buttons.apply')}
          </Button>
        </FiltersDrawerFooter>
      </Form>
    </FiltersDrawer>
  );
};

const $form = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;


export default FiltersQuestionsCertification;
